/* Clignote : quiz « Quel mot pour qui ? ». 3 questions, résultat = pack conseillé + 5 mots.
   Règle d'affichage des lunettes : 5 caractères max, en minuscules (mêmes mots que la page /pages/mots quand c'est possible). */
(() => {
  const root = document.querySelector('[data-quiz]');
  if (!root) return;
  const $ = s => root.querySelector(s);
  const form = $('[data-quiz-form]');
  const steps = [...root.querySelectorAll('.cs-q')];
  const back = $('[data-quiz-back]');
  const result = $('[data-quiz-result]');
  const email = $('[data-quiz-email]');
  let i18n = {};
  try { i18n = JSON.parse(document.querySelector('[data-quiz-i18n]').textContent); } catch (e) { /* textes absents : on garde les clés */ }

  // occasion > ton > 5 mots
  const MOTS = {
    birthday: { fun: ['vieux', 'hbd', 'lol', 'oups', '30ans'], sweet: ['love', 'bisou', 'merci', 'hbd', 'xoxo'], loud: ['yeah!', 'bday', 'party', '18ans', 'hbd'] },
    wedding: { fun: ['evjf', 'oui!', 'sos', 'team', 'lol'], sweet: ['oui!', 'love', 'jtm', 'xoxo', 'bisou'], loud: ['team', 'yeah!', 'evjf', 'party', 'oui!'] },
    party: { fun: ['lol', 'wesh', 'ouf', 'drop', 'bass'], sweet: ['love', 'peace', 'xoxo', 'bisou', 'jtm'], loud: ['drop', 'bass', 'rave', 'party', 'yeah!'] },
    halloween: { fun: ['bouh', 'boo!', 'rip', 'oups', 'miaou'], sweet: ['boo!', 'bouh', 'love', 'xoxo', 'bisou'], loud: ['666', 'peur', 'rip', 'bouh', 'boo!'] },
    newyear: { fun: ['2027', 'oups', 'hny', 'lol', 'dodo'], sweet: ['bisou', 'love', 'hny', '2027', 'xoxo'], loud: ['3-2-1', '2027', 'hny', 'yeah!', 'party'] }
  };

  let cur = 0;
  const show = n => {
    cur = n;
    steps.forEach((s, k) => { s.hidden = k !== n; });
    back.hidden = n === 0;
  };
  const value = name => (form.querySelector(`input[name="${name}"]:checked`) || {}).value;

  const finish = () => {
    const who = value('q1') || 'me', occ = value('q2') || 'birthday', tone = value('q3') || 'fun';
    const pack = i18n[who] || { t: who, d: '' };
    $('[data-r-title]').textContent = pack.t;
    $('[data-r-desc]').textContent = pack.d;
    const ul = $('[data-r-words]');
    ul.textContent = '';
    (MOTS[occ] && MOTS[occ][tone] || MOTS.birthday.fun).forEach(m => {
      const li = document.createElement('li'); li.textContent = m.toLowerCase().slice(0, 5); ul.appendChild(li);
    });
    form.hidden = true;
    result.hidden = false;
    if (email) email.hidden = false;
    $('[data-r-title]').focus({ preventScroll: true });
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  form.addEventListener('change', e => {
    if (e.target.type !== 'radio') return;
    setTimeout(() => (cur < steps.length - 1 ? show(cur + 1) : finish()), 180);
  });
  form.addEventListener('submit', e => e.preventDefault());
  back.addEventListener('click', () => show(Math.max(0, cur - 1)));
  $('[data-quiz-restart]').addEventListener('click', () => {
    form.reset(); form.hidden = false; result.hidden = true; show(0);
    steps[0].querySelector('input')?.focus();
  });

  // après envoi de l'e-mail, la page se recharge : on affiche le message de confirmation
  if (email && (email.querySelector('[data-quiz-ok]') || /customer_posted=true/.test(location.search))) email.hidden = false;
  show(0);
})();
